<template>
  <div class="vv-user">
    <div class="vv-user__avatar" aria-hidden="true">{{ initial }}</div>
    <div class="vv-user__info">
      <b class="vv-user__name">{{ displayName }}</b>
      <small class="vv-user__role">{{ $t("common.roleHr") }}</small>
    </div>
    <button
      class="vv-user__logout"
      type="button"
      data-test="sidebar-logout"
      :title="$t('common.logout')"
      :aria-label="$t('common.logout')"
      @click="logOut"
    >
      <!-- Inline SVG, not a Material-Icons ligature: the icon font is fetched
           from Google Fonts, and when that request is slow or blocked the
           ligature renders as the literal word "logout", clipped inside a 34px
           box — which is one way a sign-out button goes missing. The
           `.vv-user__logout svg` rule in vivo-shell.css was already written
           for this markup. -->
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M15 17l5-5-5-5" />
        <path d="M20 12H9" />
        <path d="M13 3H6a1 1 0 00-1 1v16a1 1 0 001 1h7" />
      </svg>
    </button>
  </div>
</template>
<script>
import { apiPost } from "../../../api/vivo/http";
import * as tokenStore from "../../../api/vivo/token-store";
import { performLogout } from "../../../api/vivo/logout";

export default {
  data() {
    return { user: {} };
  },
  computed: {
    displayName() {
      const u = this.user || {};
      return u.userName || (u.email ? u.email.split("@")[0] : "");
    },
    initial() {
      const n = this.displayName.trim();
      return n ? Array.from(n)[0].toUpperCase() : "V";
    }
  },
  methods: {
    // Teardown lives in api/vivo/logout.js so the sidebar button, the topbar
    // button and the refresh-failed path cannot drift apart.
    logOut() {
      const router = this.$router;
      return performLogout({
        post: apiPost,
        tokenStore: tokenStore,
        redirect: function () {
          router.push("/");
        }
      });
    }
  },
  created() {
    try {
      this.user = JSON.parse(localStorage.user) || {};
    } catch (e) {
      this.user = {};
    }
  }
};
</script>
